import CustomizableDashboardFeature from "./CustomizableDashboardFeature";

export default CustomizableDashboardFeature;
